import { render, staticRenderFns } from "./UserDashboards.vue?vue&type=template&id=dc023106&scoped=true"
import script from "./UserDashboards.vue?vue&type=script&lang=js"
export * from "./UserDashboards.vue?vue&type=script&lang=js"
import style0 from "./UserDashboards.vue?vue&type=style&index=0&id=dc023106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc023106",
  null
  
)

export default component.exports